<template>
  <div>
    <div v-if="preview" class="preview-form">
      <project-request
        v-model="demoResponse"
        :form="form"
        preview
      ></project-request>
      <div class="field is-grouped is-grouped-centered mt-2">
        <button class="button is-wide is-secondary" @click="preview = false">
          Close
        </button>
      </div>
    </div>
    <div v-else-if="done" class="project-request-done">
      <actions-bar>
        <div class="level">
          <div class="level-left">
            <h1 class="page-title">Project Request Form</h1>
          </div>
        </div>
      </actions-bar>

      <div class="container  has-text-centered">
        <h1 class="page-title">
          Success
        </h1>
        <p class="lead">The form has been created</p>
        <button class="button is-wide is-secondary" @click="preview = true">
          Preview Project Form
        </button>
        <p class="unique-url">
          <strong>Unique URL </strong>
          <router-link
            :to="{ name: 'form.response', params: { guid: done } }"
            target="_blank"
          >
            {{ computedUrl }}
          </router-link>
        </p>
        <router-link
          class="button is-wide is-primary"
          :to="{ name: 'projectRequests' }"
        >
          Done
        </router-link>
      </div>
    </div>
    <div v-else class="tabs">
      <tab
        title="Form Setup"
        number="1"
        :active="tab == 0"
        @click:header="tab = 0"
      >
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(() => tab++)">
            <div class="columns">
              <div class="column  is-4">
                <div class="field">
                  <ValidationProvider
                    v-slot="{ errors, failed }"
                    rules="required"
                  >
                    <label class="label">Choose Organization</label>
                    <div class="control">
                      <div class="select" :class="{ 'is-danger': failed }">
                        <select v-model="form.organizationID">
                          <option
                            v-for="r in $store.getters['groups/organizations']"
                            :key="r.organizationID"
                            :value="r.organizationID"
                            :disabled="r.disabled"
                            v-html="r.name"
                          >
                          </option>
                        </select>
                      </div>
                    </div>
                    <span class="help" :class="{ 'is-danger': failed }">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-8">
                <div class="field">
                  <ValidationProvider
                    v-slot="{ errors, failed }"
                    rules="required"
                  >
                    <label class="label">Form Name</label>

                    <div class="control">
                      <input
                        v-model="form.title"
                        class="input"
                        type="text"
                        :class="{ 'is-danger': failed }"
                      />
                    </div>
                    <span class="help" :class="{ 'is-danger': failed }">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-8">
                <div class="field">
                  <label class="label">Form Description</label>
                  <div class="control">
                    <textarea
                      v-model="form.description"
                      class="textarea"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-grouped is-grouped-centered">
              <div class="control">
                <button class="button is-primary is-wide" type="submit">
                  Continue
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </tab>
      <tab
        title="Form Questions"
        number="2"
        :active="tab == 1"
        @click:header="tab = 1"
      >
        <ValidationObserver v-slot="{ handleSubmit }">
          <draggable
            v-model="form.formQuestions"
            tag="div"
            class="question-list"
            handle=".handle"
            :animation="200"
            ghost-class="ghost"
            @start="drag = true"
            @end="drag = false"
          >
            <!-- <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
            > -->
            <question
              v-for="(question, idx) in form.formQuestions"
              :key="`question-${idx}`"
              v-model="form.formQuestions[idx]"
              is-draggable
              @remove="removeQuestion(idx)"
            ></question>
            <!-- </transition-group> -->

            <template v-slot:footer>
              <question-template
                class="is-add-button"
                @click.native="addQuestion"
              >
                <template v-slot:icon>
                  <button class="button is-text is-icon">
                    <span class="icon">
                      <font-awesome-icon icon="plus"></font-awesome-icon>
                    </span>
                  </button>
                </template>
                <template v-slot:default>
                  <div class="field">
                    <label class="label">Add question</label>
                  </div>
                </template>
              </question-template>
              <div class="field is-grouped is-grouped-centered">
                <div class="control">
                  <button
                    class="button is-secondary is-wide"
                    @click="preview = true"
                  >
                    Preview Form
                  </button>
                </div>
                <div class="control">
                  <button
                    v-if="id == undefined"
                    class="button is-primary is-wide"
                    @click="handleSubmit(addForm)"
                  >
                    Create Form
                  </button>
                  <button
                    v-else
                    class="button is-primary is-wide"
                    @click="handleSubmit(updateForm)"
                  >
                    Update Form
                  </button>
                </div>
              </div>
            </template>
          </draggable>

          <!-- <div class="question-list is-hidden">
            <question
              v-for="(question, idx) in form.formQuestions"
              :key="`question-${idx}`"
              v-model="form.formQuestions[idx]"
              @remove="removeQuestion(idx)"
            ></question>

            <question-template class="is-add-button" @click.native="addQuestion">
              <template v-slot:icon>
                <button class="button is-text is-icon">
                  <span class="icon">
                    <font-awesome-icon icon="plus"></font-awesome-icon>
                  </span>
                </button>
              </template>
              <template v-slot:default>
                <div class="field">
                  <label class="label">Add question</label>
                </div>
              </template>
            </question-template>
          </div> -->
        </ValidationObserver>
      </tab>
    </div>
    <confirm-dialog
      v-model="confirmDialog"
      title="This form already have answers do you want to make a copy?"
      action="Copy"
      icon-class="icon-copy"
      @confirmed="copyForm"
    ></confirm-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import _ from 'lodash';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import ActionsBar from '@/components/ActionsBar';
import Tab from '@/components/tabs/Tab';
import QuestionTemplate from '@/components/projectRequests/QuestionTemplate';
import Question from '@/components/projectRequests/Question';
import ProjectRequest from '@/components/projectRequests/ProjectRequest.vue';

export default {
  name: 'FormCreate',
  components: {
    Tab,
    QuestionTemplate,
    Question,
    ProjectRequest,
    ActionsBar,
    draggable,
    ConfirmDialog
  },
  props: {
    id: {}
  },
  data() {
    return {
      confirmDialog: false,
      tab: 0,
      preview: false,
      form: {
        formQuestions: []
      },
      questionFormats: [],
      demoResponse: {},
      done: false,
      drag: false
    };
  },
  computed: {
    computedUrl() {
      return (
        window.location.origin +
        this.$router.resolve({
          name: 'form.response',
          params: { guid: this.done }
        }).href
      );
    }
  },
  mounted() {
    this.axiosRequest('get', 'Forms/QuestionTypes')
      .then(response => {
        this.$store.commit('setQuestionFormats', response.data);
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
    if (this.id != undefined) {
      this.axiosRequest('get', `Forms/${this.id}`)
        .then(response => {
          this.form = response.data;
          this.$set(
            this.form,
            'formQuestions',
            _.sortBy(this.form.formQuestions, 'sortOrder')
          );
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  },
  methods: {
    addQuestion() {
      (this.form.formQuestions || (this.form.formQuestions = [])).push({
        questionType: 'TextSingleLine',
        questionText: '',
        sortOrder: 0,
        isRequired: false,
        formQuestionChoices: []
      });
    },
    removeQuestion(idx) {
      this.form.formQuestions.splice(idx, 1);
    },
    addSortOrder() {
      return {
        ...this.form,
        formQuestions: _.map(this.form.formQuestions, (q, idx) => ({
          ..._.omit(q, ['formQuestionChoices']),
          formQuestionChoices: !q.questionType.includes('MultipleChoice')
            ? []
            : _.map(q.formQuestionChoices, (choice, j) => ({
                ...choice,
                sortOrder: j
              })),
          sortOrder: idx
        }))
      };
    },
    addForm() {
      if (this.validateForm()) {
        this.axiosRequest('post', 'Forms', this.addSortOrder())
          .then(response => {
            this.done = response.data.guidToken;
          })
          .catch(error => {
            this.showErrorMessage(error);
          });
      }
    },
    updateForm() {
      if (this.validateForm()) {
        if (this.form.numberOfResponses == 0) {
          this.axiosRequest('put', `Forms/${this.id}`, this.addSortOrder())
            .then(response => {
              this.done = response.data.guidToken;
            })
            .catch(error => {
              this.showErrorMessage(error);
            });
        } else {
          //promp user to create another from based on this one
          this.confirmDialog = true;
        }
      }
    },
    validateForm() {
      if (this.form.formQuestions.length == 0) {
        this.showErrorMessage('Please add at least one question.');
        return false;
      } else {
        return true;
      }
    },
    copyForm() {
      const form = _.cloneDeep(this.form);
      form.title = form.title + ' copy';
      delete form.formID;

      this.axiosRequest('post', 'Forms', form)
        .then(response => {
          //console.log(response.data);
          this.$router.push({
            name: 'projectRequests'
          });
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss">
.page-projectRequests-view {
  .field.is-grouped-centered {
    margin-top: $block-spacing * 2;
  }
  .preview-form {
    padding-bottom: $block-spacing * 14;
  }
}
.project-request-done {
  padding-bottom: 50px;
  // height: 100%;
  > .container {
    .page-title {
      padding-top: $block-spacing * 7;
    }
    .lead {
      padding-bottom: $block-spacing * 5;
    }
    .unique-url {
      padding-top: $block-spacing * 7;
      padding-bottom: $block-spacing * 5;
    }
  }
}
.question-list {
  .flip-list-move {
    transition: transform 0.5s;
  }
}
</style>
